import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

export interface Entitlement {
  name: string;
  entitled: boolean;
}

export interface PatientEntitlements {
  patient: {
    id: string;
    entitlements: Entitlement[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class EntitlementsGraphQLService extends Query<PatientEntitlements> {
  /* istanbul ignore next */
  document = gql`
    query PatientEntitlements {
      patient {
        id
        entitlements {
          name
          entitled
        }
      }
    }
  `;
}
